import { InjectionToken } from '@angular/core';

export const AGILOX_API_ENDPOINT: InjectionToken<string> = new InjectionToken<string>(
	'AgiloxApiEndpoint'
);
